module.exports = "/_next/static/images/illustartion1-21aa237f087ef9edde210ae08a34e88e.svg";